import { useModelService } from 'services/model/model.service';
import { ListAttributeDisplayDescriptor } from 'pages/entities/entities';
import { FormattedMessage } from 'react-intl';

export function AttributeRow({ attributeCode, attributeValues, labelId, useRaw }: ListAttributeDisplayDescriptor) {
  const modelService = useModelService();

  const attribute = modelService.getAttribute(attributeCode);
  const translatedAttributeList = attributeValues
    .map(av => (useRaw ? av : attribute.translate(av)))
    .sort((a, b) => a.localeCompare(b))
    .join(', ');

  return (
    <div className="text-sm flex">
      <div className="font-semibold shrink-0 w-[150px]">
        <FormattedMessage id={labelId} />
      </div>
      <div className="flex-1">{`(${attributeValues.length}) ${translatedAttributeList}`}</div>
    </div>
  );
}
